/**
 * Promotion video - load only when the tile reaches the viewport
 *
 * An autoplaying video in the grid downloads in full on page load, even at
 * preload="none". On a paid landing page that is the entire page weight
 * spent before the visitor has scrolled to it, and most never will. This
 * holds the source back until the tile is close to view.
 */
(function () {
  'use strict';

  function load(video) {
    if (video.dataset.loaded) return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.dataset.loaded = 'true';
    video.setAttribute('src', src);
    video.removeAttribute('data-src');
    // play() can reject (autoplay policy, reduced data mode); the poster
    // stays visible in that case, which is an acceptable fallback.
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function boot() {
    var videos = document.querySelectorAll('video.promotion-video[data-src]');
    if (!videos.length) return;

    if (!window.IntersectionObserver) {
      videos.forEach(load);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Grid is replaced wholesale on filter, sort and load more
  document.addEventListener('shopify:section:load', boot);
})();
